import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	noResultsStateHeader: {
		id: 'navigation-global-side-navigation.object-list-flyout.empty-state.header',
		defaultMessage: 'No results',
		description:
			'Message for the header of the default no search results state in the object list flyout.',
	},
	noResultsStateDescription: {
		id: 'navigation-global-side-navigation.object-list-flyout.empty-state.description',
		defaultMessage: 'We couldn’t find what you’re looking for.',
		description:
			'Message for the description of the default no search results state in the object list flyout.',
	},
});

export default messages;
